import { useEffect } from 'react';

const useScrollLock = (enabled = true) =>
  useEffect(() => {
    const styles = document.documentElement.style;
    styles.overflow = enabled ? 'hidden' : '';
    return () => {
      styles.overflow = '';
    };
  }, [enabled]);

export default useScrollLock;
